export default __webpack_public_path__ + "static/media/regulatory--give-way-to-oncoming-traffic--g1.d53ac85f.png";